import { Typography } from 'antd';

export const VersionOutput = () => {
    const currentVersion = __APP_VERSION__ ?? '';

    return (
        currentVersion ? <Typography.Text className="version-output">
            v{ currentVersion }
        </Typography.Text> : ''
    );
};
